import { useState } from "react";
import { FECHA_CIERRE_PLUS, diasParaCierrePlus } from "../lib/plan";

const KEY = "mipae_aviso_lanzamiento_dismissed";

const MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

// "2026-10-05" → "5 de octubre". Puro; null si la fecha no tiene forma.
export function fechaCierreLegible(iso = FECHA_CIERRE_PLUS) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || "");
  if (!m) return null;
  const mes = MESES[Number(m[2]) - 1];
  if (!mes) return null;
  return `${Number(m[3])} de ${mes}`;
}

// Copy del aviso (exportado para test). Sin guiones largos, sin compra:
// también lo lee la app instalada. Lo ven quienes no estudian (el aviso de
// la estudiante es otro), así que anuncia lo que cambia ese día para MiPAE
// Enfermero según los Términos §6 publicados el 16-oct: la evolución con IA
// gratis pasa a ser una por semana, y el catálogo completo de fármacos y
// escalas, más de 3 procedimientos propios y el PDF de Benito pasan a las
// membresías. MiPAE TENS no necesita membresía (página de precios). Antes
// anunciaba las condiciones del 5-oct, que no llegaron a regir.
export function textoAvisoCierre(fecha) {
  return {
    titulo: `El ${fecha} empiezan las membresías.`,
    cuerpo: "Ese día, en el plan gratis de MiPAE Enfermero, la evolución completa con IA pasa a ser una por semana, y el catálogo completo de fármacos y escalas, más de 3 procedimientos propios y el PDF de Benito pasan a ser de las membresías. MiPAE TENS sigue sin necesitar membresía. Lo que ya creaste no se pierde.",
  };
}

/**
 * AvisoLanzamientoPlus — reconectado el 2026-09-14 SOLO como aviso de FECHA:
 * los Términos §6 prometen aviso antes de cualquier cambio que afecte la
 * gratuidad (7 días desde el 16-oct), y esto es ese aviso. Sin REACT_APP_PLUS_FECHA_CIERRE no pinta nada (no hay nada que
 * avisar). Con fecha: descartable hasta la recta final (≤7 días), donde
 * deja de serlo para que el cierre no tome a nadie por sorpresa.
 *
 * No tiene botón de compra ni enlace a Planes a propósito (venta solo en
 * web, y este aviso lo ve también la app instalada). UpsellPlusHome NO vuelve.
 */
export default function AvisoLanzamientoPlus() {
  const dias = diasParaCierrePlus();
  const fecha = fechaCierreLegible();
  const recta = dias !== null && dias <= 7;

  const [oculto, setOculto] = useState(() => {
    try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
  });
  if (!fecha || dias === null) return null;
  if (oculto && !recta) return null;

  const cerrar = (e) => {
    e.stopPropagation();
    try { localStorage.setItem(KEY, "1"); } catch { /* ignore */ }
    setOculto(true);
  };

  const { titulo, cuerpo } = textoAvisoCierre(fecha);

  return (
    <div role="status" className={`relative w-full rounded-tk-md border px-4 py-3.5 mb-3 ${recta ? "border-accent-border bg-accent-bg" : "border-edge bg-surface"}`}>
      {!recta && (
        <button
          type="button"
          aria-label="Descartar"
          onClick={cerrar}
          className="absolute top-2 right-2 inline-flex items-center justify-center w-6 h-6 rounded-full text-ink-faint hover:text-ink hover:bg-paper/60 transition-colors"
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
        </button>
      )}
      <div className="min-w-0 pr-6">
        <p className="text-small font-semibold text-ink font-sans leading-snug">{titulo}</p>
        <p className="text-micro text-ink-subtle font-sans mt-0.5 leading-snug">{cuerpo}</p>
      </div>
    </div>
  );
}
